var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"inline-flex brdr-none",attrs:{"type":"button","data-testid":"returnButton"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"material-icons"},[_vm._v("keyboard_backspace")])])
}
var staticRenderFns = []

export { render, staticRenderFns }